<template>
  <div>
    <page-header title="Reenviar eventos - API">
      <template #description>
        Reprocessamento manual de eventos da API que falharam. Cole os
        IDs da tabela api_events (separados por espaço) pra reenviar
        webhooks/notificações que não chegaram ao destino. Não usar IDs
        de bills ou billings.
      </template>
    </page-header>

    <div class="col-md-6">
      <div class="dashboard-panels-wrapper">
        <div class="panel panel-default dashboard-panel">
          <div class="panel-body">
            <div class="table-responsive">
              <table class="table table-hover table-spaced table-manual-config">
                <tbody>
                  <tr>
                    <td>
                      <strong>Atenção: Colocar ids da tabela 'api_events', não os ids das bills ou billings</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Eventos</strong>
                    </td>
                    <td>
                      <textarea placeholder="123 1234" v-model="eventIds"></textarea>
                    </td>
                  </tr>
                </tbody>
                <button type="button" class="btn btn-primary" @click="resendEvent()">
                  Enviar notificação
                </button>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from 'services/AdminService';

export default {
  data() {
    return {
      eventIds: '',
    };
  },
  methods: {
    resendEvent() {
      if (this.eventIds) {
        AdminService.resendApiEvent(this.eventIds).then(() => {
          this.eventIds = '';
        });
      }
    },
  },
};
</script>
